const updateLink = (link) => {
  const href = link.getAttribute('href');

  if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) {
    return;
  }

  try {
    const destination = new URL(href, window.location.href);
    const isWebLink = destination.protocol === 'http:' || destination.protocol === 'https:';

    if (isWebLink && destination.origin !== window.location.origin) {
      link.target = '_blank';
      link.relList.add('noopener', 'noreferrer');
      if (!link.title) link.title = 'Opens in a new tab — your place in the store stays open';
    }
  } catch {
    // Leave malformed or nonstandard links untouched.
  }
};

const updateLinksWithin = (root) => {
  if (root instanceof HTMLAnchorElement) {
    updateLink(root);
  }

  root.querySelectorAll?.('a[href]').forEach(updateLink);
};

updateLinksWithin(document);

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes') updateLink(mutation.target);
    mutation.addedNodes.forEach((node) => {
      if (node instanceof Element) {
        updateLinksWithin(node);
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });

// Recheck on activation, including links inserted or changed by storefront apps.
['click', 'auxclick'].forEach((type) => {
  document.addEventListener(type, (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (link) updateLink(link);
  }, true);
});
